import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { v3LegacyGroupOrderPathRedirectGuard } from './group-order-v3/v3-legacy-group-order-redirect.guard';
import { v3StorefrontOrderIdGuard } from './group-order-v3/v3-storefront-order-id.guard';

const loadGroupOrderV3 = () => import(`./group-order-v3/group-order.module`).then(m => m.GroupOrderModule);

const routes: Routes = [
  { path: '', redirectTo: 'store', pathMatch: 'full' },
  {
    path: 'pay/:hash',
    loadChildren: () =>
      import('./payment-collection/payment-collection.module').then((m) => m.PaymentCollectionModule),
  },
  {
    path: 'store',
    canActivate: [v3StorefrontOrderIdGuard],
    loadChildren: loadGroupOrderV3,
  },
  {
    path: 'group-order',
    canActivate: [v3LegacyGroupOrderPathRedirectGuard],
    loadChildren: loadGroupOrderV3,
  },
  {
    path: 'tracking',
    loadChildren: () => import(`./tracking-page/tracking-page.module`).then(m => m.TrackingPageModule),
    data: { mode: 'organizer' },
  },
  {
    path: 'participant-tracking',
    loadChildren: () => import(`./tracking-page/tracking-page.module`).then(m => m.TrackingPageModule),
    data: { mode: 'participant' },
  },
  {
    path: '**',
    loadChildren: () => import(`./subpages/page-not-found/page-not-found.module`).then(m => m.PageNotFoundModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload", initialNavigation: 'enabledBlocking', scrollPositionRestoration: 'enabled'}), HttpClientModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
